import { render, staticRenderFns } from "./native-app-download-widget.vue?vue&type=template&id=26bce4a6"
import script from "./native-app-download-widget.vue?vue&type=script&lang=js"
export * from "./native-app-download-widget.vue?vue&type=script&lang=js"
import style0 from "./native-app-download-widget.vue?vue&type=style&index=0&id=26bce4a6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports